// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2K9RB","small":"styles_small__25wKH","medium":"styles_medium__34ZvS","big":"styles_big__2ppAv","progress":"styles_progress__3LbNb"};